module.exports = __webpack_public_path__ + "img/5.adf7ffc3.jpg";